import React, { use, useEffect } from "react";
import "./Css/PrivacyPolicy.css";
const PrivacyPolicy = () => {
  useEffect(() => {
    setTimeout(() => {
      window.scrollTo({ top: "59", behavior: "smooth" });
    }, 100);
  }, []);
  return (
    <div className="privacy-policy">
      <h1>Privacy Policy</h1>

      <p>
        This privacy policy covers how we treat private information that we
        receive and collect from users. We do not intend to collect or receive
        any personal information from children under 13 unless such collection
        is permitted by law. Kindly see below for our policy regarding children
        under 13.
      </p>

      <h2>General</h2>
      <p>
        We collect user information to provide you with a personalized
        experience on our site. Your information helps us to develop games,
        tailor the services, and advertising that meet your current and future
        needs. As a result of this, we may request you to register when you
        browse certain areas of our website. You may be denied access to pages
        that require personal identification if you choose not to register.
      </p>

      <h2>Use of Information</h2>
      <p>
        When you sign up, we only ask for a unique username and password chosen
        by you, and your password will be encrypted in our database.
      </p>

      <p>
        Every communication on the Internet takes place between IP Addresses.
        Our Web servers will record the IP address that all connections are made
        from. We may use these IP addresses to prevent abuse of our systems or
        other users or help diagnose technical problems. Your IP address may
        also be used to target advertisements and gather aggregate demographic
        data.
      </p>

      <p>
        You can set up your browser to reject, accept, or notify you when a
        cookie is sent. Cookies are small text files stored in your Web browser
        for record-keeping purposes and to help us deliver better service to
        you. We use cookies to deliver content specific to your interests and to
        save your password so you do not have to re-enter it every time you
        visit our website.
      </p>

      <p>
        We employ companies to serve ads on some of our web pages. These
        companies may place and access cookies on your computer. Their use of
        cookies is governed by their own privacy policies.
      </p>

      <p>
        Our website contains links such as banner advertisements and other ads
        to external websites. We are not responsible for the privacy practices
        or the content of those websites.
      </p>

      <h2>Data Sharing</h2>
      <p>
        We do not sell or share your personal data with third parties, except
        companies that perform services for us.
      </p>

      <p>
        We may disclose personal information if required by law or in good faith
        belief that such action is necessary to comply with legal obligations,
        protect our rights or property, or protect the safety of users.
      </p>

      <p>
        In the event of a merger or acquisition, your personal data may be
        transferred to the acquiring company.
      </p>

      <h2>Google Analytics</h2>
      <p>
        htmlgames4u.com uses Google Analytics Demographics and Interest
        Reporting and other Google Analytics Advertising Features such as
        Remarketing and Google Display Network Impression Reporting.
      </p>

      <p>
        You can opt out of Google Analytics for Display Advertising by using the
        Google Ads Settings page or the Google Analytics Opt-out Browser Add-on.
      </p>

      <p>
        htmlgames4u.com and third-party vendors, such as Google, may use
        first-party and third-party cookies to serve ads based on prior visits
        to this website.
      </p>

      <h2>DoubleClick DART and Third-Party Cookies</h2>
      <p>
        We may use DoubleClick DART cookies for interest-based advertising.
        These cookies do not collect personally identifiable information such as
        name, email, address, phone number, or financial details.
      </p>

      <h2>Children Under 13</h2>
      <p>
        Our website is not intended for children under 13. We comply with the
        Children’s Online Privacy Protection Act (COPPA). We do not knowingly
        collect personal information from children under 13 unless permitted by
        law.
      </p>

      <p>
        If a parent believes their child has provided personal information, they
        may contact us, and we will remove the information promptly.
      </p>

      <h2>Security</h2>
      <p>
        We use reasonable security measures such as firewalls and password
        protection to safeguard your data. However, no method of transmission
        over the Internet is completely secure.
      </p>

      <h2>Public Areas</h2>
      <p>
        Any information posted in public areas such as chat rooms, message
        boards, or multiplayer games is public information and may be viewed by
        other users.
      </p>

      <h2>Binding Agreement</h2>
      <p>
        By using our website, you agree to this Privacy Policy and our Terms of
        Use. We reserve the right to update this policy at any time by posting
        changes on this page.
      </p>
    </div>
  );
};

export default PrivacyPolicy;
